export default __webpack_public_path__ + "static/collage-3-1e65b90200e872be10b6a6e0815ba9ca.jpg";